// Where the terminal's API calls go.
//
// Deployed terminal (terminal.corryk.com, hequity.pages.dev and its preview
// URLs): ALWAYS the same-origin `/api`, which the Cloudflare Pages worker
// (public/_worker.js) checks against Cloudflare Access and proxies to the API
// with a secret header. The API refuses terminal routes that did not come
// through that worker, so pointing a deployed build straight at the Fly host
// would break every request — the hostname check wins over VITE_API_URL.
//
// Local development (localhost): VITE_API_URL (apps/web/.env.local →
// http://127.0.0.1:3001), else `/api`. Treat an empty string as unset — Vite
// substitutes `""` for a missing variable, which is not nullish.
const DEPLOYED_HOST_RE = /(^|\.)terminal\.corryk\.com$|(^|\.)hequity\.pages\.dev$/;

function resolveApiBaseUrl(): string {
  const host = typeof location !== 'undefined' ? location.hostname : '';
  if (DEPLOYED_HOST_RE.test(host)) return '/api';
  const env = import.meta.env?.['VITE_API_URL'] as string | undefined;
  return env && env !== '' ? env : '/api';
}

export const API_BASE_URL = resolveApiBaseUrl();
